var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechCloudArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 22,
    viewBox: "0 0 45 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M0.00556791 21.9944L0 22H45L22 0L21.9944 0.00556791C21.7293 12.0304 12.0304 21.7293 0.00556791 21.9944Z",
    fill: "#DDEEF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechCloudArrow);
export default __webpack_public_path__ + "static/media/SpeechCloudArrow.68f4a6155e58717e44b6a18a25d894dd.svg";
export { ForwardRef as ReactComponent };